import { Swiper, SwiperSlide } from 'swiper/react';

export const Slider = ({ children, settings = {}, className }) => {
    const sliderOptions = {
        slidesPerView: 1,
        pagination: true,
        navigation: false,
        loop: true,
        ...settings,
    };

    return (
        <Swiper {...sliderOptions} className={className}>
            {children}
        </Swiper>
    );
};

export { SwiperSlide as Slide };
